
import {Component, Mixins} from 'vue-property-decorator';
import MenuItemComponent from '@/components/layouts/base/MenuItemComponent.vue';
import {MenuMixin} from '@/mixins/MenuMixin';
import MenuItem from '@/models/MenuItem';

@Component({
  components: {MenuItemComponent}
})
export default class BaseMenuComponent extends Mixins(MenuMixin) {
  protected navigateTo(item: MenuItem){
    if(item.children.length === 0){
      this.$router.push({name: item.route});
    }
  }
}
